import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SectionHeading } from "@/components/Cards";
import { ScrollText } from "lucide-react";

const CATS = ["All", "Traditions", "Festivals", "Astrology", "Stories"];

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => { api.get("/blogs").then((r) => setBlogs(r.data)); }, []);
  const filtered = cat === "All" ? blogs : blogs.filter((b) => b.category === cat);

  return (
    <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto py-12 lg:py-16" data-testid="blog-page">
      <p className="text-xs uppercase tracking-[0.25em] text-accent font-semibold mb-2">Vedic Blog</p>
      <h1 className="font-serif text-3xl lg:text-4xl font-bold mb-6">Wisdom, traditions & spiritual stories</h1>

      <div className="flex flex-wrap gap-2 mb-8">
        {CATS.map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`blog-cat-${c}`} className={`px-4 py-2 rounded-full text-sm border transition-colors ${cat === c ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-accent"}`}>{c}</button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((b) => (
          <Link to={`/blog/${b.slug}`} key={b.id} data-testid={`blog-card-${b.id}`} className="rounded-2xl bg-card border border-border overflow-hidden hover-lift hover:border-accent group">
            <div className="h-44 overflow-hidden"><img src={b.image} alt="" className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-700" /></div>
            <div className="p-5">
              <span className="text-xs text-accent font-medium flex items-center gap-1"><ScrollText className="h-3.5 w-3.5" /> {b.category} · {b.read_time}</span>
              <h3 className="font-serif text-lg font-semibold mt-1.5 leading-tight">{b.title}</h3>
              <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{b.excerpt}</p>
              <p className="text-xs text-muted-foreground mt-3">By {b.author} · {new Date(b.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
